import type {
  CoachingPartnership,
  CoachingPlan,
  CoachingSession,
  Cohort,
} from '@efdigital/ll-addon-data';
import eq from '@efdigital/ll-admin-v2/helpers/eq.ts';
import { isExpiredCoachConfirmation } from '@efdigital/ll-admin-v2/utils/coaching/coaching-sessions/admin-capabilities';
import type { TOC } from '@ember/component/template-only';

<template>
  {{#if (isExpiredCoachConfirmation @coachingSession)}}
    <div
      class="alert alert-warning d-flex align-items-start gap-2 mb-4"
      role="alert"
      data-test-session-alert="expired-coach-confirmation"
    >
      <iconify-icon icon="ph:clock-countdown" inline aria-hidden="true" />
      <div>
        <div class="fw-semibold">Coach confirmation window expired</div>
        <div class="mb-0">
          The coach did not confirm before the deadline. The booking should
          auto-cancel shortly if it has not already.
        </div>
      </div>
    </div>
  {{else if (eq @coachingSession.status "awaiting_attendance_review")}}
    <div
      class="alert alert-warning d-flex align-items-center gap-2 mb-4"
      role="alert"
      data-test-session-alert="awaiting-attendance-review"
    >
      <iconify-icon icon="ph:flag" inline aria-hidden="true" />
      <div>
        <div class="fw-semibold">Action required: resolve attendance</div>
      </div>
    </div>
  {{else if (eq @coachingSession.status "external_change_flagged")}}
    <div
      class="alert alert-warning d-flex align-items-start gap-2 mb-4"
      role="alert"
      data-test-session-alert="external-change-flagged"
    >
      <iconify-icon icon="ph:warning-circle" inline aria-hidden="true" />
      <div>
        <div class="fw-semibold">External calendar change detected</div>
        <div class="mb-0">
          The session may have changed in an external calendar.
        </div>
      </div>
    </div>
  {{/if}}
</template> satisfies TOC<{
  Args: {
    coachingSession: CoachingSession;
    coachingPlan: CoachingPlan;
    coachingPartnership: CoachingPartnership;
    cohort?: Cohort;
    cohortProgramId?: string;
  };
  Element: HTMLDivElement;
}>;
